export const stripeKeys = {
  account: (storeId: string) => ['stores', storeId, 'payments', 'stripe'] as const,
  applePayDomains: (storeId: string) =>
    ['stores', storeId, 'payments', 'stripe', 'apple-pay-domains'] as const,
};
